import React from 'react';
import { CheckIcon, SunIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { assurances, checkoutUrl, productBrand, productEdition } from '../data/offer';
export function FinalCta() {
  return <section className="border-t border-energy/20 bg-navy-light py-16 sm:py-20" aria-labelledby="final-title" data-id="element-58" data-mp="19g0dhjtkbyky">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-59" data-mp="15ckkqykm6idj">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-cream sm:text-4xl" data-id="element-60" data-mp="1jcvd661ko50t">
          <span className="inline-flex items-center gap-2" data-id="element-61" data-mp="1ed0lw1dvxdf8">
            <SunIcon className="h-8 w-8 shrink-0 text-gold" aria-hidden="true" data-id="element-62" data-mp="1t2ybmlrgqb6j" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-gold sm:text-2xl" data-id="element-63" data-mp="1o43hino1p074">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-haze" data-id="element-64" data-mp="221a12kglf2xe">
          Creata per insegnanti di scienze e tecnologia della scuola secondaria.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-65" data-mp="n75ovzgcwr6t">
          Ottieni ora l&apos;Edizione Docenti
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-haze" data-id="element-66" data-mp="x2qxwhjuerq2">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-67" data-mp="120scap6bq2v7">
              <CheckIcon className="h-4 w-4 text-energy" aria-hidden="true" data-id="element-68" data-mp="163p1iyqdcx84" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}